/*
 * @Author: 史金波
 * @Date: 2021-12-14 10:34:07
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-15 15:49:51
 * @FilePath: \saas-perform-web\src\api\login\loginApi.js
 */
import {httpPost,httpGet,baseUrl} from "../axiosFun.js"

export function loginapi(data) {
	return httpPost(baseUrl + "/mechant/login",data)
}



// WEBPACK FOOTER //
// ./src/api/login/loginApi.js